import {
  GalleryImg1,
  GalleryImg10,
  GalleryImg11,
  GalleryImg12,
  GalleryImg13,
  GalleryImg14,
  GalleryImg15,
  GalleryImg16,
  GalleryImg17,
  GalleryImg18,
  GalleryImg19,
  GalleryImg2,
  GalleryImg20,
  GalleryImg21,
  GalleryImg22,
  GalleryImg23,
  GalleryImg24,
  GalleryImg25,
  GalleryImg26,
  GalleryImg27,
  GalleryImg28,
  GalleryImg29,
  GalleryImg3,
  GalleryImg30,
  GalleryImg31,
  GalleryImg32,
  GalleryImg33,
  GalleryImg34,
  GalleryImg35,
  GalleryImg36,
  GalleryImg37,
  GalleryImg38,
  GalleryImg39,
  GalleryImg4,
  GalleryImg40,
  GalleryImg41,
  GalleryImg42,
  GalleryImg43,
  GalleryImg44,
  GalleryImg45,
  GalleryImg46,
  GalleryImg47,
  GalleryImg48,
  GalleryImg49,
  GalleryImg5,
  GalleryImg50,
  GalleryImg51,
  GalleryImg52,
  GalleryImg53,
  GalleryImg6,
  GalleryImg7,
  GalleryImg8,
  GalleryImg9,
} from "./ImagesS3";

const galleryStaticData = [
  {
    id: 1,
    image: GalleryImg1,
  },
  {
    id: 2,
    image: GalleryImg2,
  },
  {
    id: 3,
    image: GalleryImg3,
  },
  {
    id: 4,
    image: GalleryImg4,
  },
  {
    id: 5,
    image: GalleryImg5,
  },
  {
    id: 6,
    image: GalleryImg6,
  },
  {
    id: 7,
    image: GalleryImg7,
  },
  {
    id: 8,
    image: GalleryImg8,
  },
  {
    id: 9,
    image: GalleryImg9,
  },
  {
    id: 10,
    image: GalleryImg10,
  },
  {
    id: 11,
    image: GalleryImg11,
  },
  {
    id: 12,
    image: GalleryImg12,
  },
  {
    id: 13,
    image: GalleryImg13,
  },
  {
    id: 14,
    image: GalleryImg14,
  },
  {
    id: 15,
    image: GalleryImg15,
  },
  {
    id: 16,
    image: GalleryImg16,
  },
  {
    id: 17,
    image: GalleryImg17,
  },
  {
    id: 18,
    image: GalleryImg18,
  },
  {
    id: 19,
    image: GalleryImg19,
  },
  {
    id: 20,
    image: GalleryImg20,
  },
  {
    id: 21,
    image: GalleryImg21,
  },
  {
    id: 22,
    image: GalleryImg22,
  },
  {
    id: 23,
    image: GalleryImg23,
  },
  {
    id: 24,
    image: GalleryImg24,
  },
  {
    id: 25,
    image: GalleryImg25,
  },
  {
    id: 26,
    image: GalleryImg26,
  },
  {
    id: 27,
    image: GalleryImg27,
  },
  {
    id: 28,
    image: GalleryImg28,
  },
  {
    id: 29,
    image: GalleryImg29,
  },
  {
    id: 30,
    image: GalleryImg30,
  },
  {
    id: 31,
    image: GalleryImg31,
  },
  {
    id: 32,
    image: GalleryImg32,
  },
  {
    id: 33,
    image: GalleryImg33,
  },
  {
    id: 34,
    image: GalleryImg34,
  },
  {
    id: 35,
    image: GalleryImg35,
  },
  {
    id: 36,
    image: GalleryImg36,
  },
  {
    id: 37,
    image: GalleryImg37,
  },
  {
    id: 38,
    image: GalleryImg38,
  },
  {
    id: 39,
    image: GalleryImg39,
  },
  {
    id: 40,
    image: GalleryImg40,
  },
  {
    id: 41,
    image: GalleryImg41,
  },
  {
    id: 42,
    image: GalleryImg42,
  },
  {
    id: 43,
    image: GalleryImg43,
  },
  {
    id: 44,
    image: GalleryImg44,
  },
  {
    id: 45,
    image: GalleryImg45,
  },
  {
    id: 46,
    image: GalleryImg46,
  },
  {
    id: 47,
    image: GalleryImg47,
  },
  {
    id: 48,
    image: GalleryImg48,
  },
  {
    id: 49,
    image: GalleryImg49,
  },
  {
    id: 50,
    image: GalleryImg50,
  },
  {
    id: 51,
    image: GalleryImg51,
  },
  {
    id: 52,
    image: GalleryImg52,
  },
  {
    id: 53,
    image: GalleryImg53,
  },
];

export default galleryStaticData;
